import React from 'react';

import {
  MetadataConnectionModalScreens,
  useSFConnectionState,
} from '@contexts/sf-connection-context';

export const useViewConnection = () => {
  const {
    handleUpdateOverlayMode,
    handleUpdateSelectedConnection,
    handleUpdateMetadataConnectionModalScreen,
  } = useSFConnectionState();

  const handleEdit = (event: React.SyntheticEvent) => {
    event.preventDefault();

    handleUpdateMetadataConnectionModalScreen(
      MetadataConnectionModalScreens.CONNECTION_EDIT_SCREEN,
    );
  };

  const handleClose = (event: React.SyntheticEvent) => {
    event.preventDefault();

    handleUpdateSelectedConnection(null);
    handleUpdateOverlayMode('none');
  };

  return {
    handleClose,
    handleEdit,
  };
};
